import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getInformationUsers = (params) => {
    return axios.get(`${backendHost}/api/admin/information/users`, {params});
};

export {
    getInformationUsers
}